<template>
  <div>
    <Head title="Neue Prüfung erstellen"/>


    <div class="max-w-2xl mx-auto px-4">
      <h1 class="h1">
        DGVT Fuchs als App installieren
      </h1>
      <p class="mb-2">Browser bieten inzwischen auf einigen Websites an, die Webiste als eine <strong>Progressive Web Application (kurz: PWA)</strong> zu installieren. Wenn eine Website dafür optimiert ist, kann man die Website als App auf dem Smartphone installieren. Dadurch kann man die Website direkt als Icon starten. Alle Browser-Elemente werden ausgeblendet, so dass sich die Website wie eine richtige Smartphone App anfühlt. Der DGVT-Fuchs nutzt dieses Feature.</p>
      <p class="mb-2">Wenn du einen Browser verwendest, der nicht auf Chromium basiert (wie es z.B. Chrome oder Edge tun), können PWA Websites leider nicht direkt installiert werden. Das betrifft vor allem Firefox und Safari.</p>
      <p class="mb-2">Mit einem kleinen Umweg lässt sich dieses Problem aber einfach beheben:</p>

      <h2 class="h2 mt-8 mb-2">PWA Installation über Safari</h2>

      <div class=" mb-10 flex w-full flex-nowrap gap-4">
        <div class="">
          <a href="/img/pwa/pwa_safari_00.jpg" target="_blank"><img src="/img/pwa/pwa_safari_00.jpg" class="block w-fit" alt="PWA installieren auf Safari - Schritt 1"></a>
        </div>
        <div class="">
          <a href="/img/pwa/pwa_safari_00.jpg">
            <img src="/img/pwa/pwa_safari_01.jpg" class="block w-fit" alt="PWA installieren auf Safari - Schritt 2">
          </a>
        </div>
      </div>
      
      <h2 class="h2 mt-8 mb-2">PWA Installation über Firefox</h2>

      <div class=" mb-10 flex w-full flex-nowrap gap-4">
        <div class="">
          <a href="/img/pwa/pwa_ff_00.jpg" target="_blank"><img src="/img/pwa/pwa_ff_00.jpg" class="block w-fit" alt="PWA installieren auf Safari - Schritt 1"></a>
        </div>
        <div class="">
          <a href="/img/pwa/pwa_ff_00.jpg">
            <img src="/img/pwa/pwa_ff_01.jpg" class="block w-fit" alt="PWA installieren auf Safari - Schritt 2">
          </a>
        </div>
      </div>

    </div>

  </div>

</template>
<script>
import Layout from '../../Shared/Layout'

export default {

  name: 'Pwa',
  
  layout: Layout,
}
</script>

<style scoped>

</style>